/**
 * Copyright (c) Qwoach LLC 2026. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 */

export const GenogramNodeSizeScaleEnum = Object.freeze({
	// SMALL: 0.8,
	SMALL: 0.6,
	STANDARD: 1,
	// LARGE: 1.25,
	LARGE: 1.5,
})
